import { addDays, addWeeks, differenceInDays, format } from "date-fns"
import {
	InternalDate,
	RangeCalendar,
} from "components/Shared/MultiRangeCalendar"
import {
	PhronesisRanges,
	EMPTY_DATE_RANGE,
	DAYS_WITH_DELAY,
	DATE_FORMAT_BENCHMARK_CALENDAR,
	WEEKS_DATA_SAVED,
} from "./PhronesisCalendar.constants"
import { isSomeNull } from "helpers/objects"
import { range } from "../MultiRangeCalendar/CalendarCustomHeader/utils"

export type DateInterval = {
	currentFrom: string
	currentTo: string
	previousFrom: string
	previousTo: string
}

export const setDateRange = (
	dates: [InternalDate, InternalDate],
	index: number,
	ranges: RangeCalendar[]
): RangeCalendar[] =>
	Object.assign([], ranges, {
		[index]: {
			...ranges[index],
			startDate: dates[0],
			endDate: dates[1],
		},
	})

export const cleanPreviousRange = (ranges: RangeCalendar[]) =>
	setDateRange(EMPTY_DATE_RANGE, PhronesisRanges.Previous, ranges)

export const differencesDateRanges = ({ startDate, endDate }: RangeCalendar) =>
	differenceInDays(endDate as Date, startDate as Date)

export const isRangeSelected = ({ startDate, endDate }: RangeCalendar) =>
	!isSomeNull(startDate, endDate)

export const isStartSelection = ({ endDate }: RangeCalendar) =>
	isSomeNull(endDate)

export const generateRangeDates = (date: InternalDate, days: number) =>
	range(1, days, 1).map((step) => addDays(date as Date, step))

export const getInitialMaxDate = () => addDays(new Date(), -DAYS_WITH_DELAY)

export const getIntialMinDate = () => addWeeks(new Date(), -WEEKS_DATA_SAVED)

export const getDateFormated = (date: InternalDate) =>
	date ? format(date, DATE_FORMAT_BENCHMARK_CALENDAR) : ""

export const getDatesFromRanges = (ranges: RangeCalendar[]) => {
	const [
		[currentFrom, currentTo],
		[previousFrom, previousTo],
	] = ranges.map(({ startDate, endDate }) => [
		getDateFormated(startDate),
		getDateFormated(endDate),
	])

	return {
		previousFrom,
		previousTo,
		currentFrom,
		currentTo,
	}
}
